import { MovableInk } from 'ui/icons/dynamicContent/MovableInk';

import { useSideBySideEditorContext } from '../../../contexts/SideBySideEditorContext';
import { testIds } from '../../../constants';
import { useHandleImageModal, ImageModalType } from '../../../hooks/useHandleImageModal';
import { useTranslations } from '../../../hooks/useTranslations';
import { getCurrentElementRange, getCurrentElement } from '../../../utils';
import { ToolbarButton } from './BaseInsertButton';

export const MovableInkButton = () => {
  const { t } = useTranslations();
  const { editor } = useSideBySideEditorContext();
  const handleImageModal = useHandleImageModal();

  const onClick = () => {
    const thisEditor = editor.current;
    if (thisEditor) {
      const eltRange = getCurrentElementRange(thisEditor);
      const elt = eltRange ? getCurrentElement(thisEditor, eltRange) : undefined;

      handleImageModal(
        eltRange,
        elt?.tagName === 'IMG' ? (elt as HTMLImageElement) : undefined,
        ImageModalType.MovableInk,
      );
    }
  };

  return (
    <ToolbarButton
      onClick={onClick}
      testId={testIds.toolbarBtnMovableInk}
      tooltip={t('tooltip.buttonMovableInk')}
    >
      <MovableInk isColorInherited />
      <span>{t('button.movableInk')}</span>
    </ToolbarButton>
  );
};
